export default __webpack_public_path__ + "static/media/screen9.d1785397.svg";